import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';

const ChatBotRestoreButton = () => {
  const [showTooltip, setShowTooltip] = useState(false);
  const location = useLocation();

  // Check if we should show the restore button based on the current page
  const shouldShowOnPath = () => {
    const HIDE_ON_PATHS = [
      '/admin-dashboard',
      '/admin/',
      '/employee-portal',
      '/employee/',
      '/login',
      '/register'
    ];
    
    return !HIDE_ON_PATHS.some(path => location.pathname.startsWith(path));
  };

  const handleRestore = () => {
    localStorage.removeItem('hideChatBot');
    window.location.reload();
  };

  // Don't render on admin or employee portal pages
  if (!shouldShowOnPath()) {
    return null;
  }

  return (
    <div 
      className="restore-chatbot-container"
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      <button 
        onClick={handleRestore}
        className="restore-chatbot-button"
        aria-label="Restore chat assistant"
      >
        ?
      </button>
      {showTooltip && (
        <div className="restore-chatbot-tooltip">
          Restore chat assistant
        </div>
      )}
      <style jsx>{`
        .restore-chatbot-container {
          position: fixed;
          bottom: 20px;
          right: 20px;
          z-index: 999;
        }
        
        .restore-chatbot-button {
          width: 30px;
          height: 30px;
          border-radius: 50%;
          background-color: rgba(76, 175, 80, 0.3);
          color: white;
          border: none;
          font-size: 16px;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.2s ease;
        }
        
        .restore-chatbot-button:hover {
          background-color: rgba(76, 175, 80, 0.8);
        }
        
        .restore-chatbot-tooltip {
          position: absolute;
          bottom: 40px;
          right: 0;
          background-color: #333;
          color: white;
          padding: 5px 10px;
          border-radius: 4px;
          font-size: 12px;
          white-space: nowrap;
        }
        
        .restore-chatbot-tooltip:after {
          content: '';
          position: absolute;
          top: 100%;
          right: 10px;
          border-width: 5px;
          border-style: solid;
          border-color: #333 transparent transparent transparent;
        }
      `}</style>
    </div>
  );
};

export default ChatBotRestoreButton; 